<template>
	<div class="catalog-dialog-options">
		<div class="catalog-dialog-options-container" :style="`background-color: ${theme.base};`">
			<button
				class="catalog-dialog-options-close"
				type="button"
				:style="`background-color: ${theme.base};`"
				@click="$emit('stay')"
			>
				<img
					src="/static/images-new/icons/close-red.svg"
					height="10"
					alt=""
				/>
			</button>
			<button
				class="catalog-dialog-options-btn catalog-dialog-options-btn-outline"
				type="button"
				@click="$emit('stay')"
			>
				Continuar en la web
				<p class="catalog-dialog-options-btn-commerce">
					Tienda {{ commerceName }}
				</p>
			</button>
			<button
				class="catalog-dialog-options-btn catalog-dialog-options-btn-full"
				type="button"
				:style="`color: ${theme.base};`"
				@click="$emit('go-to-app')"
			>
				Ir a la aplicación
			</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'catalog-dialog-options',
		props: {
			commerceName: String,
			theme: {
				default: () => {},
				type: Object,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.catalog-dialog-options {
		align-items: center;
		background-color: rgba(0, 0, 0, .3);
		bottom: 0px;
		display: flex;
		flex-wrap: wrap;
		height: 100vh;
		justify-content: center;
		left: 0px;
		position: absolute;
		right: 0px;
		top: 0px;
		width: 100vw;
		z-index: 4;

		&-container {
			align-items: center;
			border-radius: 8px;
			display: flex;
			flex-direction: column;
			flex-wrap: wrap;
			height: 206px;
			justify-content: center;
			position: relative;
			width: 268px;
		}

		&-close {
			border-radius: 100%;
			box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
			height: 30px;
			position: absolute;
			right: 5px;
			top: 11px;
			width: 30px;
		}

		&-btn {
			border-radius: 25px;
			height: 50px;
			width: 231px;
		}

		&-btn-outline {
			border: 1px solid currentColor;
			color: #ff5252;
			font-size: 14px;
			font-weight: weight(semibold);
			margin-bottom: 10px;
		}

		&-btn-commerce {
			font-size: 13px;
			font-weight: weight(bold);
			margin: 0px;
		}

		&-btn-full {
			background-color: #ff5252;
			font-size: 15px;
			font-weight: weight(bold);
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/catalog/catalog-dialog-options.vue